<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>CONTENTS</h1>
</header>
<p class="toc"><a class="xref" href="#/chipanglereason0007#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0008#ch01">1   The Task and the Puzzle of Reason in the <i>Nicomachean Ethics</i> (<i>NE</i> 1 and 2)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0009#ch02">2   Knowledge, Choice, and Responsibility for Character (<i>N</i><i>E</i> 3.1–5)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0010#ch03">3   Reason and Purpose in the Moral Virtues (<i>N</i><i>E</i> 3.6–4.9)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0011#ch04">4   Justice and the Rule of Reason (<i>N</i><i>E</i> 5)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0012#ch05">5   Wisdom and Active Wisdom: The Intellectual Virtues (<i>N</i><i>E</i> 6)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0013#ch06">6   Problems of Self-Control (<i>N</i><i>E</i> 7.1–10)</a></p>
<p class="toc"><a class="xref" href="#/chipanglereason0014#epil">Epilogue: The Philosophic Life (<i>N</i><i>E</i> 10.6–8)</a></p>
<p class="tocbmf"><a class="xref" href="#/chipanglereason0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chipanglereason0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chipanglereason0017#ch07">Bibliography of Modern Works and Editions</a></p>
<p class="tocbm"><a class="xref" href="#/chipanglereason0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-pangle-reason-0006.vue?6c69b990